import React from 'react';
import { Button, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';
import {BiRupee} from 'react-icons/bi';
import { HashLink as Link } from 'react-router-hash-link';
import { IoIosArrowForward } from "react-icons/io";
import discount33 from '../../../images/discount33.png';

import './Mobile.css';
import { propTypes } from 'react-bootstrap/esm/Image';


function MobileCard({photo,header,content,address,bookUrl,btnTitle,oldPrice,newPrice,picLink}) {
    return (
        <div  style={{padding:'10px'}}>
            <Container  fluid className='Box'>
                <Row className='globalWrapper'>
                    <Col sm={5} xs={5} md={5} lg={5}>
                        <Link to={picLink}>
                            <img src={photo} alt='premiumroom' className='photo' />
                        </Link>
                        
                    </Col>
                    <Col sm={7} xs={7} md={7} lg={7} className='infoWrapper' >
                        <div className='headerTitle'>
                            <h4>{header}</h4>
                        </div>
                        <div className='content'>
                            <p>
                                {content}
                                <div className='wholeBox'>
                                    <div className='priceBox'>
                                         <div className='priceRoom'>
                                                <h6 style={{marginRight:'10px'}}>From</h6>
                                            <span className='lineBar'>
                                                <h5><BiRupee />{oldPrice} /</h5>
                                                <h6>per night*</h6>
                                            </span>
                          
                                        </div>

                                        <div className='priceRoom2'>
                          
                                            <h5><BiRupee />{newPrice} /</h5>
                                            <h6>per night*</h6>
                                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px'}}>inclusive of all taxes - GST</p> */}
                                        </div>
                                            <p className='tax-inclusion' >inclusive of all taxes - GST</p>
                                    </div>

                                    <div className='bloc-discount'>
                                        <img src={discount33} className='discount33' alt='logo' />
                                    </div>
                                </div>
                            </p>

                        </div>
                    
                    </Col>
                    
                    <div className='wholeBox saf'>
                                    <div className='priceBox'>
                                         <div className='priceRoom'>
                                                <h6 style={{marginRight:'10px'}}>From</h6>
                                            <span className='lineBar'>
                                                <h5><BiRupee />{oldPrice} /</h5>
                                                <h6>per night*</h6>
                                            </span>
                          
                                        </div>

                                        <div className='priceRoom2'>
                          
                                            <h5><BiRupee />{newPrice} /</h5>
                                            <h6>per night*</h6>
                                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px'}}>inclusive of all taxes - GST</p> */}
                                        </div>
                                            <p className='tax-inclusion' >inclusive of all taxes - GST</p>
                                    </div>

                                    <div className='bloc-discount'>
                                        <img src={discount33} className='discount33' alt='logo' />
                                    </div>
                                </div>

                </Row>

                

                <div className='readmoreClass'>
                        <Link  to={address} style={{fontSize:'12px',color:'#4d3319', textTransform:'uppercase'}}>read more <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </Link>
                </div>
                <span>
                    <a href={bookUrl}>
                        <Button  className='bookMobile' >{btnTitle}</Button>
                    </a>
                    
                </span>
                
            </Container>
            
        </div>
    )
}

export default MobileCard
